
export default {
  name: 'ListActions',
  props: {
    del: {
      type: Boolean,
      default: () => false
    },
    delTitle: {
      type: String,
      default: 'Hapus'
    },
    showDetail: {
      type: Boolean,
      default: () => false
    },
    showDetailTitle: {
      type: String,
      default: 'Lihat Detail'
    }
  }
}
